const ReturoIconHome = () => (
  <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_4284_11181)" />
    <path
      d="M46.18 51.5757C55.1242 48.6071 60.1296 39.4349 57.7631 30.5823C55.4901 22.0724 47.5656 17.2617 40.0537 17.5357C40.0537 18.3426 40.0537 19.1494 40.0537 20.04C37.1345 18.609 34.3088 17.2312 31.3975 15.8078C34.301 14.3844 37.1345 12.9991 40.0459 11.5757C40.0459 12.4663 40.0459 13.2655 40.0459 14.0952C46.6938 14.1713 52.1195 16.6604 56.1518 21.8136C59.032 25.5053 60.3086 29.745 60.0362 34.3806C59.4913 43.7508 52.4464 49.9468 46.18 51.5757Z"
      fill="white"
    />
    <g clip-path="url(#clip0_4284_11181)">
      <path
        d="M47.649 34.0388L35.4615 25.643C35.1842 25.4523 34.818 25.4523 34.5396 25.643L22.3521 34.0388C22.1311 34.1905 22 34.4408 22 34.7083V50.4167C22 51.0147 22.4853 51.5 23.0833 51.5H25.25V38.5C25.25 37.902 25.7353 37.4167 26.3333 37.4167H43.6667C44.2647 37.4167 44.75 37.902 44.75 38.5V51.5H46.9167C47.5147 51.5 48 51.0147 48 50.4167V34.7083C48 34.4408 47.8689 34.1905 47.649 34.0388Z"
        fill="white"
      />
      <path
        d="M32.0205 46.0833V46.8958C32.0205 47.3443 31.6565 47.7083 31.208 47.7083C30.7595 47.7083 30.3955 47.3443 30.3955 46.8958V46.0833H28.4997C28.2007 46.0833 27.958 46.3259 27.958 46.6249V50.9583C27.958 51.2573 28.2007 51.4999 28.4997 51.4999H33.9163C34.2153 51.4999 34.458 51.2573 34.458 50.9583V46.6249C34.458 46.3259 34.2153 46.0833 33.9163 46.0833H32.0205Z"
        fill="white"
      />
      <path
        d="M39.6045 46.0833V46.8958C39.6045 47.3443 39.2405 47.7083 38.792 47.7083C38.3435 47.7083 37.9795 47.3443 37.9795 46.8958V46.0833H36.0837C35.7847 46.0833 35.542 46.3259 35.542 46.6249V50.9583C35.542 51.2573 35.7847 51.4999 36.0837 51.4999H41.5003C41.7993 51.4999 42.042 51.2573 42.042 50.9583V46.6249C42.042 46.3259 41.7993 46.0833 41.5003 46.0833H39.6045Z"
        fill="white"
      />
      <path
        d="M35.8125 39.5833V40.3958C35.8125 40.8443 35.4485 41.2083 35 41.2083C34.5515 41.2083 34.1875 40.8443 34.1875 40.3958V39.5833H32.2917C31.9927 39.5833 31.75 39.8259 31.75 40.1249V44.4583C31.75 44.7573 31.9927 44.9999 32.2917 44.9999H37.7083C38.0073 44.9999 38.25 44.7573 38.25 44.4583V40.1249C38.25 39.8259 38.0073 39.5833 37.7083 39.5833H35.8125Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_4284_11181"
        x1="35"
        y1="0"
        x2="35"
        y2="70"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFB300" />
        <stop offset="1" stop-color="#EA8D03" />
      </linearGradient>
      <clipPath id="clip0_4284_11181">
        <rect width="26" height="26" fill="white" transform="translate(22 25.5)" />
      </clipPath>
    </defs>
  </svg>
)

export default ReturoIconHome
